import { util } from '@/plugins/util'
import Vue from 'vue'

export default {
  setAttendanceValidation(state, validation) {
    state.attendance.data.validatePhases = validation
  },
  setAttendance(state, attendance) {
    state.attendance = attendance
  },
  setOriginalAttendance(state, attendance) {
    state.originalAttendance = util.copy(attendance)
  },
  setCurrentStepIndex(state, stepIndex) {
    state.currentStepIndex = stepIndex
  },
  setCurrentPhaseIndex(state, phaseIndex) {
    state.currentPhaseIndex = phaseIndex
  },
  setAttendanceMode(state, mode) {
    state.attendance.mode = mode
  },
  setAttendanceVersion(state, version) {
    state.attendance.version = version
  },
  setAttendanceNote(state, note) {
    state.attendance.note = note
  },
  setAttendanceWeightKg(state, weightKg) {
    state.attendance.weightKg = weightKg
  },
  setAttendanceHeightCm(state, heightCm) {
    state.attendance.heightCm = heightCm
  },
  setAttendanceMedicalReport(state, report) {
    state.attendance.report = report
  },
  setAttendanceMedicalReportReferences(state, references) {
    state.attendance.references = references
  },
  setAttendanceHypothesis(state, hypothesis) {
    state.attendance.hypothesis = hypothesis
  },
  setAttendanceSummary(state, summary) {
    state.attendance.summary = summary
  },
  setPhaseData(state, { key, data }) {
    Vue.set(state.attendance.data, key, data)
  },
  setLocalSyncedData(state, value) {
    state.isLocalSyncedData = value
  },
  setServerSyncedData(state, value) {
    state.isServerSyncedData = value
  },
  setSavingData(state, value) {
    state.isSavingData = value
  },
  updatePatientData(state, partialPatientData) {
    if(state.attendance?.patient){
      state.attendance.patient = {
        ...state.attendance.patient,
        ...partialPatientData,
      }
    }
  },
  setPatientAcceptedTerms(state, value) {
    if (state.attendance?.patient) {
      state.attendance.patient.acceptedTerms = value
    }
  },
}
